export const leaveData = [
    {
      key: "1",
      leaveType: "Medical Leave",
      leaveDate: "05 May 2024 - 09 May 2024",
      noOfDays: "5",
      appliedOn: "05 May 2024",
      status: "Approved"
    },
    {
      key: "2",
      leaveType: "Casual Leave",
      leaveDate: "07 May 2024 - 07 May 2024",
      noOfDays: "1",
      appliedOn: "07 May 2024",
      status: "Approved"
    },
    {
      key: "3",
      leaveType: "Special Leave",
      leaveDate: "09 May 2024 - 09 May 2024",
      noOfDays: "1",
      appliedOn: "09 May 2024",
      status: "Pending"
    },
    {
      key: "4",
      leaveType: "Casual Leave",
      leaveDate: "08 May 2024 - 08 May 2024",
      noOfDays: "1",
      appliedOn: "04 May 2024",
      status: "Approved"
    },
    {
      key: "5",
      leaveType: "Medical Leave",
      leaveDate: "08 May 2024 - 11 May 2024",
      noOfDays: "4",
      appliedOn: "08 May 2024",
      status: "Pending"
    },
    {
      key: "6",
      leaveType: "Casual Leave",
      leaveDate: "20 May 2024 - 20 May 2024",
      noOfDays: "1",
      appliedOn: "19 May 2024",
      status: "Pending"
    }
  ];
  